import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

// RxJs
import { Observable, switchMap } from 'rxjs';

// Providers
import { SecurityService } from '@core/providers/services/security/security.service';



@Injectable()
export class SecurityInterceptor implements HttpInterceptor {

  private clone!: HttpRequest<unknown>;


  constructor(
    private readonly securityService: SecurityService,
  ) { }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.securityService.getOA2T().pipe(
      switchMap(({ token }: any) => {
        this.clone = request.clone({ setHeaders: { Authorization: `Bearer ${ token }` }});
        return next.handle(this.clone);
      })
    )
  }
}
